const AttatchedIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width={"1em"}
        height={"1em"}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.66675 4.66699V3.50033C4.66675 2.21166 5.71142 1.16699 7.00008 1.16699C8.28872 1.16699 9.33341 2.21166 9.33341 3.50033V10.5003C9.33341 11.789 8.28872 12.8337 7.00008 12.8337C5.71142 12.8337 4.66675 11.789 4.66675 10.5003V7.87533C4.66675 7.06992 5.31967 6.417 6.12508 6.417C6.93049 6.417 7.58341 7.06992 7.58341 7.87533V9.33366"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default AttatchedIcon;
